import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';
const RememberTableStateContext = /*#__PURE__*/createContext([{}, () => ({})]);
export const useResetRememberTableState = () => {
  const [, setStates] = useContext(RememberTableStateContext);
  return useCallback(() => {
    setStates(() => ({}));
  }, []);
};
export const useRememberTableState = name => {
  const [{
    [name]: tableData = {}
  }, setStates] = useContext(RememberTableStateContext);
  return useMemo(() => {
    return [tableData, data => {
      setStates(prev => ({ ...prev,
        [name]: typeof data === 'function' ? data(prev[name]) : data
      }));
    }]; // eslint-disable-next-line
  }, [tableData]);
};

const RememberTableState = ({
  children
}) => {
  const states = useState({});
  return /*#__PURE__*/React.createElement(RememberTableStateContext.Provider, {
    value: states
  }, children);
};

export default RememberTableState;